
import { ContactAutofill } from "@/models/contact-autofill";
import Vue from "vue";
import AppField from "./DossierEditAutoFillModalField.vue";

export interface IAutoFillSelectedFields {
	address:boolean;
	postal:boolean;
	city:boolean;
	tel:boolean;
	companyName:boolean;
}

export default Vue.extend({
	data(){
		return {
			selectedFields: {
				address: false,
				postal: false,
				city: false,
				tel: false,
				companyName: false
			} as IAutoFillSelectedFields
		};
	},
	props: {
		data: {
			type: Object as ()=>ContactAutofill,
			required: true
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("confirm", this.selectedFields);
			this.$emit("close");
		}
	},
	components: {
		AppField
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
